// src/services/cookieService.js

/**
 * Sets a cookie with the given name, value, and options
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {Object} options - Cookie options (expires, path, etc.)
 */
export const setCookie = (name, value, options = {}) => {
    const defaultOptions = {
        path: '/',
        sameSite: 'strict',
        // Default expiration of 7 days
        expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString(),
        // Add secure flag in production
        ...(window.location.protocol === 'https:' ? { secure: true } : {}),
        ...options
    };

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    Object.entries(defaultOptions).forEach(([key, val]) => {
        cookieString += `; ${key}=${val}`;
    });

    document.cookie = cookieString;
};

/**
 * Gets a cookie by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
export const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
};

/**
 * Removes a cookie by name
 * @param {string} name - The name of the cookie to remove
 */
export const removeCookie = (name) => {
    document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};